

























import { Component, Vue } from 'vue-property-decorator';
import { IBusinessType } from '@/models/business';
import { openCenterModal } from '@/utils/modal';

import flagKeys from '@/constants/flagKeys';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ArrowLinkUp from '@/components/icons/ArrowLinkUp.vue';
import { isBothProvider } from '@/utils/provider';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    FilledButton,
    ArrowLinkUp
  }
})
export default class BannerActivateOnlineInStore extends Vue {
  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get enableToActiveOnlineInStore() {
    const currentProvider = this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];

    if (
      !this.flags.includes(flagKeys.addWixMultipleIntegration) ||
      !currentProvider ||
      !currentProvider.name ||
      !isBothProvider(currentProvider.name) ||
      this.business.coinRewardPercentage === '0.00'
    )
      return false;

    const { startBy } = this.$store.getters['startGuide/getPreferences'];

    if (
      this.business.operationType === IBusinessType.BOTH &&
      startBy &&
      startBy === IBusinessType.ONLINE
    )
      return true;

    return this.business.operationType === IBusinessType.ONLINE;
  }

  learnMoreClick() {
    segmentIo.track('Clicked Support Link Physical_Online Rewards', {
      Origin: 'Banner'
    });
  }

  onOpenActivateOnlinInStore() {
    openCenterModal('onlineInStoreModal', {
      mobilePositionBottom: true,
      notShowNotificationArrow: true,
      byBanner: true
    });
  }
}
